// Team colours are "random but stable": the palette order is shuffled by a PRNG
// seeded from the league id, and teams take slots in numeric id order. No storage.
export const TEAM_PALETTE_SIZE = 16;

function hashString(text) {
  let hash = 2166136261; // FNV-1a
  for (const ch of String(text)) {
    hash ^= ch.codePointAt(0);
    hash = Math.imul(hash, 16777619);
  }
  return hash >>> 0;
}

function mulberry32(seed) {
  let state = seed;
  return () => {
    state = (state + 0x6d2b79f5) | 0;
    let t = Math.imul(state ^ (state >>> 15), 1 | state);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function paletteOrder(leagueId) {
  const random = mulberry32(hashString(leagueId));
  const order = Array.from({ length: TEAM_PALETTE_SIZE }, (_, i) => i + 1);
  for (let i = order.length - 1; i > 0; i -= 1) {
    const j = Math.floor(random() * (i + 1));
    [order[i], order[j]] = [order[j], order[i]];
  }
  return order;
}

function compareIds(a, b) {
  const byNumber = Number(a) - Number(b);
  return Number.isNaN(byNumber) || byNumber === 0 ? a.localeCompare(b) : byNumber;
}

export function assignTeamColors(leagueId, teamIds) {
  const order = paletteOrder(leagueId);
  const unique = [...new Set((teamIds ?? []).filter(id => id != null).map(String))].sort(compareIds);
  // ponytail: past 16 teams colours repeat in order, by design (spec §5b).
  return new Map(unique.map((id, i) => [id, order[i % TEAM_PALETTE_SIZE]]));
}

export function teamColorVar(slot) {
  return slot ? `var(--team-${slot})` : 'var(--ledger-line-2)';
}

export function youStyle(slot) {
  if (!slot) return {};
  return {
    '--you': `var(--team-${slot})`,
    '--you-ink': `var(--team-${slot}-ink)`,
    '--you-row': `color-mix(in srgb, var(--team-${slot}) 12%, transparent)`,
  };
}
